export class CommonMessages {
  public static DownloadPDF = 'DOWNLOAD_PDF';
  public static CreatePDF = 'CREATE_PDF';
  public static DownloadPPTX = 'DOWNLOAD_PPTX';
  public static CreatePPTX = 'CREATE_PPTX';
  public static ResetReportFilters = 'RESET_REPORT_FILTERS';
  public static Copy = 'COPY';
  public static Paste = 'Paste';
}
